import React from 'react'
import styles from './SaleBonusPill.module.css'

// The sale's free extra (lib/saleCampaign getSaleBonus) as a pill under a deal:
// "+ 3 months VRS Competitive  ~~€29.97~~  FREE". Added value only, never part
// of the price. theme: 'light' on white cards, 'dark' on black sections.
function GiftIcon() {
  return (
    <svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M14 5h-1.6c.2-.3.3-.7.3-1.1C12.7 2.3 11.4 1 9.9 1 9 1 8.4 1.5 8 2.2 7.6 1.5 7 1 6.1 1 4.6 1 3.3 2.3 3.3 3.9c0 .4.1.8.3 1.1H2c-.6 0-1 .4-1 1v2c0 .5.4.9.9 1V14c0 .6.4 1 1 1h10.2c.6 0 1-.4 1-1V9c.5-.1.9-.5.9-1V6c0-.6-.4-1-1-1Zm-4.1-2.6c.8 0 1.4.7 1.4 1.5S10.7 5 9.9 5H8.8V3.9c0-.8.3-1.5 1.1-1.5ZM4.7 3.9c0-.8.6-1.5 1.4-1.5.8 0 1.1.7 1.1 1.5V5H6.1c-.8 0-1.4-.3-1.4-1.1ZM2.4 6.4h4.9v1.2H2.4V6.4Zm.9 2.6h4v4.6h-4V9Zm9.4 4.6h-4V9h4v4.6Zm.9-6h-4.9V6.4h4.9v1.2Z"/>
    </svg>
  )
}

function SaleBonusPill({ bonus, theme = 'light', className }) {
  if (!bonus || !(bonus.short || bonus.label)) return null
  return (
    <span
      className={[styles.pill, theme === 'dark' ? styles.dark : styles.light, className].filter(Boolean).join(' ')}
      title={`${bonus.label}${bonus.worth ? `, worth ${bonus.worth}` : ''}, free with your order`}
    >
      <GiftIcon/>
      <span className={styles.label}>+ {bonus.short || bonus.label}</span>
      {bonus.worth && <s className={styles.worth}>{bonus.worth}</s>}
      <span className={styles.free}>FREE</span>
    </span>
  )
}

export default SaleBonusPill
